import { SSRProvider } from 'react-bootstrap'
import { AppProvider } from '../hooks/useAppContext'
import { Route, Routes } from 'react-router-dom'
import React from 'react'
import Layout from '../components/layout'
import { routesDef } from '../config/routes'
import HomePage from './home'
import DataDeletionRequestPage from './data-deletion-request'
import NotFoundPage from './NotFound'
import PayrollPage from './payroll'
import HaulerPage from './hauler'
import HaulerNextPage from './hauler-next'
import LabPage from './lab'
import PrincipalPage from './principal'
import DocsPage from './docs'
import DocItemPage from './docs/posts'
import PolicyTosPage from './docs/policy-tos'
import '../assets/bs5.scss'

export default function App({ routeContext }: { routeContext?: Record<string, any> }) {
  return (
    <AppProvider routeContext={routeContext}>
      <SSRProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path={routesDef.HomePage.path} element={<HomePage />} />
            <Route path={routesDef.DataDeletionRequest.path} element={<DataDeletionRequestPage />} />
            <Route path={routesDef.PayrollPage.path} element={<PayrollPage />} />
            <Route path={routesDef.HaulerPage.path} element={<HaulerPage />} />
            <Route path={routesDef.HaulerNextPage.path} element={<HaulerNextPage />} />
            <Route path={routesDef.LabPage.path} element={<LabPage />} />
            <Route path={routesDef.PrincipalPage.path} element={<PrincipalPage />} />
            <Route path={routesDef.DocsPage.path} element={<DocsPage />} />
            <Route path={routesDef.DocItemPage.path} element={<DocItemPage />} />
          </Route>

          <Route path={'/:app/terms-and-condition/:version'} element={<PolicyTosPage />} />
          <Route path={'/:app/privacy-policy/:version'} element={<PolicyTosPage />} />

          <Route path={'*'} element={<NotFoundPage />} />
        </Routes>
      </SSRProvider>
    </AppProvider>
  )
}
